module.exports = __webpack_public_path__ + "static/media/redBin.fcf2f70d.svg";